<template>
  <div>
    <header>
      <h1>
        <button class="toggle-menu-button" @click="menuOpen = true">
          <span class="material-icons" style="font-size: 2rem"> menu </span>
        </button>
      </h1>
      <nav class="header-nav">
        <h1>
          <router-link to="/">NFL Ironman</router-link>
        </h1>
        <ul>
          <li v-if="isAdmin">
            <router-link :to="{ path: '/admin' }">Admin</router-link>
          </li>
          <li>
            <router-link :to="{ path: '/' }">Home</router-link>
          </li>
          <li v-if="isLoggedIn && !tournamentPickingOpen">
            <router-link :to="{ path: '/weeklygames' }">Weekly Games</router-link>
          </li>
          <li v-if="isLoggedIn">
            <router-link :to="{ path: '/users/' + currentUserId + '/picks' }"
              >My Picks</router-link
            >
          </li>
          <li v-if="isLoggedIn">
            <router-link :to="{ path: '/users/' + currentUserId }"
              >My Profile</router-link
            >
          </li>
          <li v-else>
            <router-link to="/auth">Login / Register</router-link>
          </li>
          <li v-if="isLoggedIn">
            <base-button @click="logout">Logout {{ userName }}</base-button>
          </li>
          <li>
            <router-link to="/about">About</router-link>
          </li>
        </ul>
      </nav>
    </header>
    <base-menu :show="menuOpen" @close="menuOpen = false">
      <nav class="mobile-nav">
        <h1>
          <router-link to="/">NFL Ironman</router-link>
        </h1>
        <ul>
          <div v-if="isAdmin">
            <li>
              <router-link :to="{ path: '/admin' }" exact>Administration</router-link>
            </li>
            <ul class="submenu">
              <li>
                <router-link to="/admin/seasons" exact>Seasons</router-link>
              </li>
              <li>
                <router-link to="/admin/teams" exact>Teams</router-link>
              </li>
              <li>
                <router-link to="/admin/schedules" exact>Schedules</router-link>
              </li>
              <li>
                <router-link to="/admin/users" exact>Users</router-link>
              </li>
              <li>
                <router-link to="/admin/weeks" exact>Weeks</router-link>
              </li>
              <li>
                <router-link to="/admin/dataexport" exact>Data Export</router-link>
              </li>
            </ul>
          </div>
          <li>
            <router-link :to="{ path: '/' }">Home</router-link>
          </li>
          <li v-if="isLoggedIn && !tournamentPickingOpen">
            <router-link :to="{ path: '/weeklygames' }">Weekly Games</router-link>
          </li>
          <li v-if="isLoggedIn">
            <router-link :to="{ path: '/users/' + currentUserId + '/picks' }"
              >My Picks</router-link
            >
          </li>
          <li v-if="isLoggedIn">
            <router-link :to="{ path: '/users/' + currentUserId }"
              >My Profile</router-link
            >
          </li>
          <li v-else>
            <router-link to="/auth">Login / Register</router-link>
          </li>
          <li v-if="isLoggedIn" @click="logout">
            <router-link @click="logout" to="/auth"
              >Logout {{ userName }}</router-link
            >
          </li>
          <li>
            <router-link to="/about">About</router-link>
          </li>
        </ul>
      </nav>
    </base-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuOpen: false,
    };
  },
  computed: {
    currentUserId() {
      return this.$store.getters.userId;
    },
    userName() {
      return this.$store.getters.userName;
    },
    isLoggedIn() {
      return this.$store.getters.isAuthenticated;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    tournamentPickingOpen() {
      return this.$store.getters['seasons/currentSeason'].tournamentPickingOpen;
    },
    headerColor() {
      return this.$store.getters.backgroundColor;
    },
    buttonColor() {
      return this.$store.getters.foregroundColor;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.replace("/");
    },
  },
};
</script>

<style scoped>


header {
  width: 100%;
  height: 4rem;
  background-color: v-bind(headerColor);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

header a {
  text-decoration: none;
  color: v-bind(buttonColor);
  display: inline-block;
  padding: 0.75rem 1rem;
  border: 1px solid transparent;
  font-size: 0.8rem;
}

header button {
  font-size: 0.8rem;
}

header a:active,
header a:hover,
header a.router-link-active {
  border: 1px solid v-bind(buttonColor);
}

header h1 {
  margin: 0;
}

header h1 a {
  color: white;
  margin: 0;
}

header h1 a:hover,
header h1 a:active,
header h1 a.router-link-active {
  border-color: transparent;
}

header nav {
  width: 90%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

header ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: none;
  justify-content: center;
  align-items: center;
}

header li {
  margin: 0 0.5rem;
}

.toggle-menu-button {
  width: 3rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding-top: 0;
  padding-bottom: 0;
  vertical-align: middle;
  color: white;
}

.toggle-menu-button:focus {
  outline: none;
}

@media (min-width: 64rem) {
  .toggle-menu-button {
    display: none;
  }

  header ul {
    display: flex;
  }
}

@media (min-width: 80rem) {
  header a {
    font-size: 1.25rem;
  }

  header button {
    font-size: 1.25rem;
  }
}

.mobile-nav {
  position: fixed;
  top: 0;
  left: 0;
  background: v-bind(buttonColor);
  height: 100vh;
  z-index: 200;
}

.mobile-nav a {
  text-decoration: none;
  color: v-bind(headerColor);
  display: inline-block;
  padding: 0.75rem 1.5rem;
  border: 1px solid transparent;
}

.mobile-nav a:active,
.mobile-nav a:hover,
.mobile-nav a.router-link-exact-active {
  border: 1px solid v-bind(headerColor);
}

.mobile-nav h1 a.router-link-active {
  border: 0;
}

.mobile-nav ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: inline-block;
  justify-content: center;
  align-items: center;
}

.submenu li {
  list-style: inside;
  color: v-bind(foregroundColor);
  margin: 0 0 0 1rem;
}

.submenu li a {
  margin-left: 0;
}
</style>